export const checkInputHourSecValidity = (value: string, maxHours: number = 23) => {
    const time = value.split(':')
    const hours = parseInt(time[0])
    const isCorrectHours = 0 <= hours && hours <= maxHours
    if (time.length === 1) {
        if (isCorrectHours) {
            return {
                hours,
                mins: 0,
                secs: 0
            }
        }
        return false
    } else if (time.length === 2) {
        const mins = parseInt(time[1])
        const isCorrectMins = 0 <= mins && mins <= 59
        if (isCorrectHours && isCorrectMins) {
            return {
                hours,
                mins,
                secs: 0
            }
        }
    } else if (time.length === 3) {
        const mins = parseInt(time[1])
        const isCorrectMins = 0 <= mins && mins <= 59
        const secs = parseInt(time[2])
        const isCorrectSecs = 0 <= secs && secs <= 59
        if (isCorrectHours && isCorrectMins && isCorrectSecs) {
            return {
                hours,
                mins,
                secs
            }
        }
    }
    return false
}

export const getInputHourWidth = (number: number) => {
    const parsedNumber = String(number)
    if (parsedNumber.length === 1) {
        return (2 * 8) + 'px'
    } else if (parsedNumber.length >= 5) {
        return (parsedNumber.length * 8) + 4 + 'px'
    }

    return (parsedNumber.length * 8) + 'px'
}